var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavorite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2633 22.6187C14.554 23.2627 13.462 23.2627 12.7526 22.6094L12.65 22.5161C7.74996 18.0827 4.54863 15.1801 4.66996 11.5587C4.72596 9.97207 5.53796 8.45074 6.85396 7.55474C9.31796 5.87474 12.3606 6.65874 14.0033 8.5814C15.646 6.65874 18.6886 5.8654 21.1526 7.55474C22.4686 8.45074 23.2806 9.97207 23.3366 11.5587C23.4673 15.1801 20.2566 18.0827 15.3566 22.5347L15.2633 22.6187Z",
    fill: "#EDEFF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorite);
export default __webpack_public_path__ + "static/media/favorite.8d00f9b75d46992d9b78856547f70ea1.svg";
export { ForwardRef as ReactComponent };